package com.milta.core.localization.translations.bg

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Моят абонамент",
    screenSubtitle = "Управлявайте абонамента си за Milta",
    planDriver = "Шофьор",
    planOrganisation = "Компания",
    statusActive = "Активен",
    statusTrial = "Пробен период",
    statusExpired = "Изтекъл",
    statusCancelled = "Анулиран",
    platformLabel = "Платформа",
    productIdLabel = "Продукт",
    expiresAtLabel = "Изтича на",
    noExpiry = "Без дата на изтичане",
    noValue = "—",
    noSubscription = "Няма активен абонамент",
    activateButton = "Активирайте абонамент",
    successActivated = "Абонаментът е активиран успешно",
    perMonth = "/месец",
    pitchTitle = "Отключете всички функции на Milta",
    pitchSubtitle = "Изберете плана, подходящ за дейността ви, за да продължите да доставяте и управлявате курсовете си.",
    featuredBadge = "ВСИЧКО ВКЛЮЧЕНО",
    driverFeature1 = "Неограничени курсове и доставки",
    driverFeature2 = "Снимка доказателство за доставка + подпис",
    driverFeature3 = "Известия в реално време",
    orgFeature1 = "Неограничено управление на екип",
    orgFeature2 = "Пълен уеб панел",
    orgFeature3 = "Импортиране на курсове (Excel, PDF, снимка)",
    orgFeature4 = "Включен достъп като шофьор за вас",
    purchaseFinePrint = "Сигурно плащане през магазина. Отказ по всяко време от настройките на магазина.",
    purchasingLabel = "Обработва се…",
    activeCaption = "Вашият абонамент за Milta",
    nextRenewalLabel = "Следващо подновяване",
    includedTitle = "Включено във вашия план",
    manageOnGooglePlay = "Управление в Google Play",
    manageOnAppStore = "Управление в App Store",
    viewTechnicalDetails = "Вижте техническите детайли",
    monthNames = listOf("януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"),
    errorNotFound = "Не е намерен активен абонамент",
    errorConflict = "За този акаунт вече съществува активен абонамент",
    errorPlanMismatch = "Избраният план не съответства на ролята на акаунта ви",
    errorPlanRequired = "Моля, изберете план",
    errorPlanInvalid = "Избраният план е невалиден",
    errorPlatformRequired = "Платформата е задължителна",
    errorPlatformInvalid = "Невалидна платформа. Трябва да е AppStore или GooglePlay",
    errorStoreProductIdRequired = "ID на продукта в магазина е задължително",
    errorReceiptTokenRequired = "Токенът на разписката е задължителен",
    errorGeneric = "Възникна грешка. Моля, опитайте отново.",
    trialBannerDaysPrefix = "🎉 Безплатен пробен период: остават ви ",
    trialBannerDaysBold = "%d дни",
    trialBannerDaysSuffix = ", за да опознаете Milta без обвързване.",
    trialBannerHoursPrefix = "⏰ Безплатният ви пробен период приключва след ",
    trialBannerHoursBold = "%d ч",
    trialBannerHoursSuffix = ": абонирайте се, за да продължите да ползвате Milta без прекъсване.",
    coveredByEnterprise = "Покрито от абонамента на вашата фирма",
    myEnterprisesTitle = "Моите фирми",
    enterpriseCoversYou = "Покрива ви",
    enterpriseSubscriptionExpired = "Изтекъл абонамент",
    myEnterprisesFootnote = "Вашите фирми оптимизират маршрутите, които ви изпращат, със собствените си кредити. Не виждате тяхното потребление.",
    takeDriverPlanForOwnUse = "За да оптимизирате собствените си маршрути и да използвате ИИ сами, вземете абонамент Шофьор.",
    ownPlanNotNeededWhenCovered = "Покрити сте от вашата фирма, личният ви абонамент не е необходим. Той служи за оптимизациите, които стартирате сами.",
)
